// components/UserPeriodForm/index.tsx
import React from 'react';
import moment from 'moment';

import { UserPeriod } from '@/typings/models/User';
import { PeriodFormUI } from '@/components/ResourceSettings/PeriodFormUI';

interface UserAvailabilityFormProps {
  value?: UserPeriod[];
  onChange?: (periods: UserPeriod[]) => void;
  mode: 'open' | 'off';
}

const UserPeriodForm: React.FC<UserAvailabilityFormProps> = ({ value = [], onChange, mode }) => {

  const deduplicatedValue = React.useMemo(() => {
    const seen = new Set<string>();
    return value.filter((p: any) => {
      const key = `${p.start}-${p.end}-${p.date || ''}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [value]);

  const handleChange = (newPeriods: UserPeriod[]) => {
    const formattedPeriods: UserPeriod[] = mode === 'off'
      ? newPeriods.map(p => ({
        start: p.start,
        end: p.end,
      }))
      : newPeriods.map(p => (p.date ? p : {
        date: moment(p.start).format('YYYY-MM-DD'),
        start: moment(p.start).format('HH:mm'),
        end: moment(p.end).format('HH:mm'),
      }));

    onChange?.(formattedPeriods);
  };

  return (
    <PeriodFormUI
      mode={mode === 'off' ? 'block' : 'open'}
      periods={deduplicatedValue}
      onAdd={(period) => handleChange([...deduplicatedValue, period])}
      onRemove={(newPeriods) => handleChange(newPeriods)}
      onChange={handleChange}
    />
  );
};

export default UserPeriodForm;
